var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"blog"}},[_c('div',{staticClass:"py-12"}),_c('v-container',[_c('h2',{staticClass:"display-2 font-weight-bold mb-3 text-uppercase text-center pt-10"},[_vm._v("Partners")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }